import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CallIcon from '@mui/icons-material/Call';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Button from '@mui/material/Button';
// import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AppLogo from './../assets/logo2.png'

const pages = ['Products', 'Services', 'Technology', 'Blog', 'Contact'];
const settings = ['Profile', 'Logout'];

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  // const handleOpenUserMenu = (event) => {
  //   setAnchorElUser(event.currentTarget);
  // };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar position="sticky" sx={{
      borderBottom: '1px outset',
      backgroundColor: 'Snow',
      pl: {xs: .5, md: 7.5}, 
      pr: {xs: .5, md: 7.5}
    }}>
      <Container maxWidth="xl" sx={{color: 'white'}}>
        <Toolbar disableGutters sx={{ color: 'rgb(0, 133, 252)'}}>
          {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontWeight: 700,
              letterSpacing: '.3rem',
              textDecoration: 'none',
            }}
          >
            LOGO
          </Typography> */}

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Button
                    key={page}
                    href={`#${page}`}
                    onClick={handleCloseNavMenu}
                    sx={{ my: 2, display: 'block', m: 0 }}
                  >
                    {page}
                  </Button>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h6"
            noWrap
            component="a"
            className='text-neon'
            href="#Products"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontWeight: 'bolder',
              letterSpacing: 'rem',
              textDecoration: 'none',
            }}
          >
            Pridim Technology
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            <Box display={'flex'} flexDirection={'column'} alignitems={'center'} justifyContent="center">
              <a href="#Products" display='flex' alignitems="center" >
                <Box
                  component="img"
                  src={AppLogo}
                  width="100px"
                  height="42px" 
                  alt={"Home"}
                />
              </a>
              <Box component="span" className='text-xs text-neon'>Pridim Technology</Box>
            </Box>
            <Box display={'flex'} flex={1} justifyContent={'center'}>
              {pages.map((page) => {
                return <Button
                  key={page}
                  href={`#${page}`}
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, display: 'block' }}
                >
                  {page}
                </Button>
              })}
            </Box>
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Box display="flex" flexDirection="row" alignitems="center">
              <Box sx={{
                display: {xs: 'none', md: 'flex'}, flexDirection:'column', alignitems: 'center',
                fontSize: '12px', mr: 1, color: '#000' 
              }}>
                <Button
                  sx={{backgroundColor: '#FF5C00', color: '#ffffff', p: 1}}
                >
                  <>Call Us <CallIcon size={18} sx={{mr: 1, ml: 1}} /></>
                  <b>+91 8686340975</b>
                </Button>
              </Box>
              {/* <Tooltip title="Open Profile">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <AccountCircleIcon fontSize='32px' />
                </IconButton>
              </Tooltip> */}
            </Box>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
